window.toggleGhHead = function() {
  var ghBurger = document.querySelector('.gh-burger');
  var body = document.querySelector('body');

  ghBurger.addEventListener('click', function () {
    body.classList.toggle('gh-head-open');
  });
}

